'use strict';

module.exports = [
  '$modal',
  '$scope',
  '$miscUtils',
  'TeamTypeDomain',
  '$toast',
  'teamType',
  'organization',
  TeamTypesCreateController];

function TeamTypesCreateController($modal, $scope, $miscUtils, TeamTypeDomain, $toast, existingType, organization) {
  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/

  const vm = $scope.teamTypesCreate = initViewModel(this, existingType);
  vm.save = $miscUtils.blockPromise(save);
  vm.cancel = !existingType ?
    $modal.cancel.bind($modal) :
    function revertDataAndClose() {
      vm.model.$revert();
      return $modal.cancel();
    };


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function save() {
    if (!vm.model.$validate()) {
      return Promise.reject(vm.$errors);
    } else {
      return vm.model.$save()
        .then(function () {
          if (!existingType) {
            $toast.showI18nMessage({
              messageId: 'teams.types.create.success.message',
              messageParams: {teamType: vm.model.name},
              type: 'info',
            });
          }
          return $modal.hide(vm.model);
        }, function (error) {
          console.error('an error occurred', error);
        });// TODO: show errors in view
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Load Data
   ****************************************************************************************************************/


  function initViewModel(vm, teamType) {
    if (teamType) {
      vm.model = teamType;
    } else {
      vm.model = TeamTypeDomain.$factory.create();
      vm.model.organization = organization;
    }

    return vm;
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/admin/TeamTypesCreateController.js